/* eslint-disable no-console */
import { QueryClient } from '@tanstack/react-query';

function queryErrorHandler(error) {
  const title = error instanceof Error ? error.message : 'error connecting to server';
  console.log(title);
  // SnackbarUtils.error(title);
}

export function generateQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        onError: queryErrorHandler,
        staleTime: 600000, // 10 minutes
        cacheTime: 900000, // default cacheTime is 5 minutes;
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: !(process.env.NODE_ENV === 'test'), // set retry to false for tests
      },
      mutations: {
        onError: queryErrorHandler,
      },
    },
  });
}

export const queryClient = generateQueryClient();
